// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__1YH_P","inverted":"Footer_inverted__11dmV","content":"Footer_content__GADOx","innerContent":"Footer_innerContent__1fUH-"};